import React, { useState, useEffect } from "react";
import {Link, useLocation, useHistory } from "react-router-dom";
import * as Dapp from "@elrondnetwork/dapp";
//import TransferNFTModal from "./TransferNFTModal";

import { db } from "../../Firebase.js";
import { getFirestore, collection, addDoc, setDoc, doc } from 'firebase/firestore';

const Inventory = () => {
    const { loggedIn, address } = Dapp.useContext();
    const [inputAddress, setInputAddress] = useState();
    const [componentDidMount, setComponentDidMount] = useState(false);
    const history = useHistory();
    //erd1tztluf08g90max7jkr4jtac9w5qv7qacgkhh57q9nz2erq9y2p3sd5njkg
    //erd1964efrfe0h0rcg9vck4c4wdmesvatm6860mj8dyk2neudnkuk5jqudz3lz

    let pathname = window.location.pathname;
    useEffect(() => {
        pathname = window.location.pathname;
    }, [window.location.pathname]);
    
    React.useEffect(() => {
        if (componentDidMount)
            return;
        if (!loggedIn) {
            history.push('/wallet-connect')
        }
        setComponentDidMount(true);
    }, []);

    return (
    <>
            <div className="row">
                <div className="col-12">
                    {/* Intro */}
                    <div className="intro text-center">
                        <div className="intro-content text-center">
                            <span>Wallet Inventory</span>
                            <h3 className="mt-3 mb-0">Elrond NFT Wallet Content</h3>
                            <p className="mt-3 mb-0">{address}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="item-form no-hover mt-4 mb-4">
                <div className="row navbar navbar-expand">
                    <ul className="navbar-nav items mx-auto">
                        <li className="nav-item"  >
                            <Link to="/wallet" className={`${pathname.match('/wallet') ? 'active nav-link' : 'nav-link'} `}  >  Wallet Items </Link>
                        </li>
                        <li className="nav-item d-none" >
                            <Link to="/wallet-collections" className={`${pathname.match('/wallet-collection') ? 'active nav-link' : 'nav-link'} `} >  Wallet Collections </Link>
                        </li>
                        <li className="nav-item"  >
                            <Link to="/my-collections" className={`${pathname.match('/my-collections') ? 'active nav-link' : 'nav-link'} `}  >  My collections </Link>
                        </li>
                    </ul>
                    
                    
                    
                </div>
            </div>
    </>
    )
}

export default Inventory;